import React, {Component} from 'react';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';
import ContentDialog from './content-dialog';
import NewContentDialog from './new-content-dialog';

/** @class ContentsList
 * A component for editing and rearranging a
 * list of booth contents.
 */
export default class ContentsListComponent extends Component {
  /** @constructor
    * Constructs a new ContentListComponent
    */
  constructor(props) {
    super(props);
    //const contents = processContents(this.props.contents);
    this.state = {
      contents: this.processContents(this.props.contents),
      selectedContent: '',
      showNewDialog: false
    }
    this.dataURL = props.dataURL;
    this.processContents = this.processContents.bind(this);
    this.handleSortEnd = this.handleSortEnd.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleUnselect = this.handleUnselect.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.togglePublished = this.togglePublished.bind(this);
    this.handleNew = this.handleNew.bind(this);
    this.toggleNewDialog = this.toggleNewDialog.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      contents: this.processContents(newProps.contents)
    });
  }
  /** @method processContents
    * Helper method for converting a contents map into
    * an array form used for rendering.
    */
  processContents(contentMap) {
    var contents = [];
    Object.keys(contentMap || {}).forEach((key) => {
      contents.push({
        id: key,
        data: contentMap[key],
        dataURL: `${this.props.dataURL}/${key}`
      });
    });
    return contents.sort((a,b) => a.data.order - b.data.order);
  }
  /** @function handleSortEnd
    * Updates the list item positions after
    * the users has rearranged them.
    * @param {Object} - object with two parameters,
    * oldIndex and newIndex - the items to switch in
    * the contents array.
    */
  handleSortEnd({oldIndex, newIndex}){
    var contents = arrayMove(this.state.contents, oldIndex, newIndex);
    var updates = {}
    contents.forEach((content, i) => {
      if(content.data.order !== i) {
        content.data.order = i;
        updates[content.dataURL] = content.data;
      }
    });
    firebase.database().ref().update(updates);
  }
  /** @function handleSelect
    * Displays a ContentDialog component for
    * the selected content to allow for editing it.
    * @param {String} id - the id of the content
    * to edit in the database
    */
  handleSelect(id) {
    this.setState({selectedContent: id, showEditDialog: true});
  }
  /** @function handleUnselect
    * Conceals any visible ContentDialog components
    */
  handleUnselect() {
    this.setState({selectedContent: ''});
  }
  /** @function handleRemove
    * Removes the selected content from this booth
    * @index {String} id - the id of the content to
    * remove in the database.
    */
  handleRemove(id) {
    var dataURL = `${this.dataURL}/${id}`;
    firebase.database().ref(dataURL).remove();
  }
  /** @function togglePublished
    * Toggles the published status of the selected content item
    * @index {integer} - the index of the content item to
    * publish or unpublish in the contents array.
    */
  togglePublished(id) {
    var dataURL = `${this.dataURL}/${id}`;
    var content = this.state.contents.find((content)=>{
      return content.id === id;
    });
    content.data.published = !content.data.published;
    firebase.database().ref(dataURL).set(content.data);
  }
  /** @function toggleNewDialog
    * Toggles the visibility of the NewContentDialog
    */
  toggleNewDialog() {
    this.setState({showNewDialog: !this.state.showNewDialog});
  }
  /** @function handleNew
    * Creates a new content item of the specified type
    * and adds it to the contents array.
    * @param {String} type - the type of the content to add.
    */
  handleNew(type) {
    const newContent = {
      name: "New Content",
      type: type,
      columns: 1,
      order: this.state.contents.length
    }
    var child = firebase.database().ref(this.dataURL).push(newContent);
    this.setState({
      showNewDialog: false,
      selectedContent: child.key
    });
  }
  /** @function render
    * Renders the contents list.
    */
  render() {
    const editDialogs = this.state.contents.map((content, index) => (
      <ContentDialog
        key={'edit-dialog-'+index}
        show={this.state.selectedContent === content.id}
        content={content.data}
        dataURL={content.dataURL}
        onExit={this.handleUnselect}
        />
    ));
    return(
      <div>
        <SortableList
          items={this.state.contents}
          useDragHandle={true}
          onSortEnd={this.handleSortEnd}
          onRemoveContent={this.handleRemove}
          onSelectContent={this.handleSelect}
          onTogglePublished={this.togglePublished}
          />
          <button onClick={this.toggleNewDialog}>
            <FontAwesome name="plus"/>
            Add New Content
          </button>
          {editDialogs}
          <NewContentDialog
            show={this.state.showNewDialog}
            onExit={this.toggleNewDialog}
            onChooseType={this.handleNew}
            />
        </div>
    );
  }
}

/* A Drag handle for the sortable list */
const DragHandle = SortableHandle(() => <FontAwesome name="reorder"/>);

/* An item in the sortable list */
const SortableListItem = SortableElement((props) => {
  return(
    <div className="sortable-list-item">
      <span>
        <DragHandle />
      </span>
      {props.content.name}
      <span>
        <FontAwesome name={props.content.published?"flag":"ban"}
          style={{color: "#4eba6f"}}
          onClick={props.onTogglePublished}
          />
        <FontAwesome name="edit"
          style={{color: "#965ba5"}}
          onClick={props.onSelectContent}
          />
        <FontAwesome name="times"
          style={{color: "red"}}
          onClick={props.onRemoveContent}
          />
      </span>
    </div>
  );
});

/* The sortable list */
const SortableList = SortableContainer((props) => {
  return (
    <div className="sortable-list">
      {props.items.map((content, index) => (
        <SortableListItem
          key={`item-${index}`}
          index={index}
          content={content.data}
          onSelectContent={()=>{props.onSelectContent(content.id)}}
          onRemoveContent={()=>{props.onRemoveContent(content.id)}}
          onTogglePublished={()=>{props.onTogglePublished(content.id)}}
          />
      ))}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/booth-editor/contents-list.js